import { Link } from "react-router-dom";
import { useLang } from "../i18n";

export default function NotFoundPage() {
  const { lang } = useLang();
  const prefix = lang === "ca" ? "/ca" : "";
  return (
    <div data-testid="not-found-page" className="flex min-h-[80svh] flex-col items-center justify-center px-4 pt-32 text-center">
      <p className="font-display text-8xl font-black text-[#63E51D]">404</p>
      <h1 className="mt-4 font-display text-3xl font-bold uppercase tracking-wide text-white">
        {lang === "ca" ? "Pàgina no trobada" : "Página no encontrada"}
      </h1>
      <Link
        to={prefix || "/"}
        data-testid="not-found-home-link"
        className="mt-8 rounded-full bg-[#63E51D] px-8 py-3.5 font-display text-lg font-bold uppercase tracking-wide text-black transition-all duration-300 hover:scale-[1.03]"
      >
        {lang === "ca" ? "Tornar a l'inici" : "Volver al inicio"}
      </Link>
    </div>
  );
}
